var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 12.857,
    viewBox: "0 0 10 12.857",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Delete_-_Default",
    "data-name": "Delete - Default",
    d: "M8.214,15.929a1.433,1.433,0,0,0,1.429,1.429h5.714a1.433,1.433,0,0,0,1.429-1.429V7.357H8.214ZM17.5,5.214H15L14.286,4.5H10.714L10,5.214H7.5V6.643h10Z",
    transform: "translate(-7.5 -4.5)",
    fill: "#b9b9b9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteDefault);
export default __webpack_public_path__ + "static/media/Delete - Default.996e181430e7433e94f1ebaa6574ab89.svg";
export { ForwardRef as ReactComponent };